// extracted by mini-css-extract-plugin
export default {"root":"ViewerButton__root--3cET4","icon":"ViewerButton__icon--2Kaoo"};